import { render, staticRenderFns } from "./OrderMailReceiver.vue?vue&type=template&id=8be7fa48&"
import script from "./OrderMailReceiver.vue?vue&type=script&lang=js&"
export * from "./OrderMailReceiver.vue?vue&type=script&lang=js&"
import style0 from "./OrderMailReceiver.vue?vue&type=style&index=0&id=8be7fa48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports